var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_910_640)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1142 11.2407L7.65079 1.41496C7.00212 0.858958 6 1.31987 6 2.17422L6 21.8258C6 22.6801 7.00212 23.141 7.65079 22.585L19.1142 12.7593C19.5798 12.3602 19.5798 11.6398 19.1142 11.2407Z",
  fill: "#06262D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_910_640"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47715 4.47715 0 10 0H14C19.5228 0 24 4.47715 24 10V24H0V10Z",
  fill: "white"
})))));
export { SvgPlayFill as ReactComponent };
export default __webpack_public_path__ + "images/play-fill.svg";